import { Component } from '@angular/core';

@Component({
  selector: 'app-left-dobble-arrow-svg-icon',
  templateUrl: './left-dobble-arrow-svg-icon.component.html',
  styleUrls: [],
})
export class LeftDobbleArrowSvgIconComponent {}
